import { query, collection, orderBy, where } from 'firebase/firestore';
import styles from './SafeguardCheckHistory.module.css';
import {
  EbpCaseChange,
  dateTimeToLocalDateTimeString,
} from '@packages/core-shared';
import { AlertError, Spinner } from '@percihealth/react';
import { useSubscribeFirestoreList } from '../../../hooks/useSubscribeFirestoreList';
import { useMemo } from 'react';
import { useFirebase } from '../../../context';

export default function SafeguardCheckHistory({ formId }: { formId: string }) {
  const { firestore } = useFirebase();

  const queryResult = useMemo(() => {
    const q = query(
      collection(firestore, `forms/${formId}/changes`),
      where('type', '==', 'safeguardCheck'),
      orderBy('createdAt', 'desc'),
    );
    return q;
  }, [firestore, formId]);

  const changesLoader = useSubscribeFirestoreList<EbpCaseChange>(queryResult);

  return (
    <div className={styles.container}>
      {changesLoader.loading && <Spinner />}
      {changesLoader.records.map((change) => (
        <div
          key={dateTimeToLocalDateTimeString(change.createdAt)}
        >{`${dateTimeToLocalDateTimeString(change.createdAt)}: ${
          change.author
        } marked as ${change.new ? 'checked' : 'unchecked'}`}</div>
      ))}
      {changesLoader.errorMessage && (
        <AlertError>{changesLoader.errorMessage}</AlertError>
      )}
    </div>
  );
}
